/*
 * @Author: caiqin.xie
 * @since: 2023-07-26 19:01:25
 * @lastTime: 2024-01-02 15:21:44
 * @LastEditors: caiqin.xie
 * @message: Popular Forums详情
 * @url: www.picoxr.com/cn/support/popular-forums:seoUrl
 */
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Header from "@/components/Header/index";
import Footer from "@/components/Footer/index";
import ArticleTitle from "./components/ArticleTitle";
import request from '@/common/request'
import { getUrlData } from '@/common/untils'
import { DOMAIN_API, COUNTRY_HREFLANG, POPULARFORUMSTYPE } from '@/common/const'
import { IContentDetail } from "@/common/types";
import styles from "./index.module.scss";
import classNames from "classnames";

const PopularForumsDetail = (props: any) => {
  const {ctry, words, data} = props.data
  const [newsDetail, setNewsDetail] = useState<IContentDetail>(data?.content || null) // 内容详情

  // 渲染HTML
  function creatHtml () {
    return {__html: newsDetail?.detail}
  }

  // 生成hreflang
  const renderHrefLang = () => {
    return (
      newsDetail && newsDetail.stationCodes && newsDetail.stationCodes.map(item => (
        <link key={item} rel="alternate" hrefLang={COUNTRY_HREFLANG[item]} href={`${DOMAIN_API}/${item}/support/popular-forums/${newsDetail?.seoUrl}`} />
      ))
    )
  }

  return (
    <div>
      <Helmet>
        <title>{newsDetail?.seoTitle}</title>
        <meta name="description" content={newsDetail?.seoDescription} />
        <meta name="keywords" content={newsDetail?.seoKeywords} />
        <link rel="canonical" href={newsDetail?.seoCanonical} />
        {renderHrefLang()}
        <script type="application/ld+json">
          {newsDetail?.structuredCode}
        </script>
      </Helmet>
      <Header ctry={ctry} words={words}/>
      <main className={styles['news-wrap']}>

        {/* 内容区 */}
        <div className={styles["content-wrap"]}>
          <section className={`${styles['section']} ${styles['section-article']}`}>
            {/* 新闻标题 */}
            <ArticleTitle ctry={ctry} words={words} newsDetail={newsDetail} />
            {/* 新闻内容 */}
            <article className={classNames(styles['article-content'], 'editor-wrap')} dangerouslySetInnerHTML={creatHtml()}></article>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

function getInit (ctry: string, pathName: string) {
  return new Promise((resolve, reject) => {
    const decodedUrl = decodeURIComponent(pathName);
    const seoUrl = decodedUrl.split('?')[0].split('/').pop();
    const query = getUrlData(decodedUrl)
    request.post(`${DOMAIN_API}/o/official/content/getNewsDetailGather`, {
      contentTypeId: POPULARFORUMSTYPE,
      seoUrl: seoUrl,
      stationCode: ctry,
      page: query.page || 1,
      rows: 8
    })
    .then(res => {
      resolve(res.data)
    })
    .catch(err => {
      reject(err)
    })
  })
}

PopularForumsDetail.getInitialProps = (ctry: string, pathName: string) => {
  return getInit(ctry, pathName)
};
export default PopularForumsDetail;
